/**
 * Soul Store
 *
 * Manages the user's SOUL state — persona, priorities, preferences.
 * Persisted to localStorage for instant access on subsequent loads.
 */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { UserSoul } from "@/services/soul-service";

interface SoulState {
	soul: UserSoul | null;
	isLoading: boolean;
	hasFetched: boolean;
	setSoul: (soul: UserSoul | null) => void;
	setLoading: (loading: boolean) => void;
	setHasFetched: (fetched: boolean) => void;
	clearSoul: () => void;
}

export const useSoulStore = create<SoulState>()(
	persist(
		(set) => ({
			soul: null,
			isLoading: false,
			hasFetched: false,
			setSoul: (soul: UserSoul | null) => set({ soul, hasFetched: true }),
			setLoading: (isLoading: boolean) => set({ isLoading }),
			setHasFetched: (hasFetched: boolean) => set({ hasFetched }),
			clearSoul: () => set({ soul: null, hasFetched: false }),
		}),
		{
			name: "facilityai-soul",
			storage: createJSONStorage(() => localStorage),
		},
	),
);
